import React from 'react';
import ordersIcon from '../../src/assets/ordersImg.png';
import ticTacToeIcon from '../../src/assets/tictactoeImg.png';
import slotMachineIcon from '../../src/assets/slotMachineImg.png';
import reclaimIcon from '../../src/assets/reclaimImg.png';
import stocklogicIcon from '../../src/assets/stocklogic_logo.png';
import useWindowSize from './useWindowSize';

export default function Projects() {
    const isMobile = useWindowSize().isMobile;

    const projectsContainerStyle = {
        padding: isMobile ? '1.5rem 1rem' : '2.5rem',
        width: '100%',
        boxSizing: 'border-box',
        backgroundColor: 'rgba(18, 18, 18, 0.55)',
        backdropFilter: 'blur(16px) saturate(120%)',
        boxShadow: '0 8px 32px 0 rgba(0, 0, 0, 0.5)',
        border: '1px solid rgba(255, 255, 255, 0.1)',
        borderRadius: '16px',
        WebkitMaskImage: 'linear-gradient(to bottom, black 80%, transparent 100%)',
        maskImage: 'linear-gradient(to bottom, black 80%, transparent 100%)',
    }

    const projListStyle = {
        display: 'grid',
        gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fit, minmax(220px, 1fr))',
        gap: '25px',
        listStyleType: 'none',
        padding: '0',
        margin: '0',
        width: '100%',
    }

    const projListLi = {
        backgroundColor: 'rgba(255, 255, 255, 0.05)',
        border: '1px solid rgba(255, 255, 255, 0.1)',
        borderRadius: '16px',
        padding: '20px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        transition: 'transform 0.2s, background-color 0.2s',
        boxSizing: 'border-box',
    }

    const projListLiA = {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'space-between',
        height: '100%',
        width: '100%',
        gap: '15px',
        fontSize: isMobile ? '1.1em' : '1.3em',
        fontWeight: 'bold',
        color: '#ffffff',
        textDecoration: 'none',
        fontFamily: '"Open Sans", sans-serif',
        fontVariant: 'small-caps',
        textAlign: 'center',
    }

    const projIcon = {
        height: '80px',
        width: '80px',
        objectFit: 'contain',
        borderRadius: '12px',
        boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
    }

    return (
        <div className="Projects" style={projectsContainerStyle}>
            <ul style={projListStyle}>
                <li style={projListLi}>
                    <a href="https://ericdsergio.webhop.me/Pages/inventory/" style={projListLiA} target="_blank" rel="noreferrer">
                        StockLogic <br />(New Version)
                        <img style={projIcon} src={stocklogicIcon} alt="StockLogic Inventory Management" />
                    </a>
                </li>
                <li style={projListLi}>
                    <a href="https://ericdsergio.webhop.me/Pages/orders/index.html" style={projListLiA} target="_blank" rel="noreferrer">
                        Inventory Management<br />(Old Version)
                        <img style={projIcon} src={ordersIcon} alt="Order App icon" />
                    </a>
                </li>
                <li style={projListLi}>
                    <a href="https://ericdsergio.webhop.me/Pages/tictactoe/index.html" style={projListLiA} target="_blank" rel="noreferrer">
                        Tic Tac Toe
                        <img style={projIcon} src={ticTacToeIcon} alt="Tic Tac Toe App icon" />
                    </a>
                </li>
                <li style={projListLi}>
                    <a href="https://ericdsergio.webhop.me/Pages/slotMachine/index.html" style={projListLiA} target="_blank" rel="noreferrer">
                        Slot Machine
                        <img style={projIcon} src={slotMachineIcon} alt="Slot Machine App icon" />
                    </a>
                </li>
                <li style={projListLi}>
                    <a href="https://ericdsergio.webhop.me/index.html#" style={projListLiA} target="_blank" rel="noreferrer">
                        Reclaim
                        <img style={projIcon} src={reclaimIcon} alt="Reclaim game documentation icon" />
                    </a>
                </li>
            </ul>
        </div>
    );
}
